import api from '@/services/api'
import {setToken} from '@/services/api'

export const userLoggedIn = () => !!localStorage.getItem("token")

export default {
	login(username, password) {
		return api.post(`token-auth/`, {username, password})
			.then(res => {
				const token = res.data.token
				if (token === null) {
					throw new Error("token is null");
				} 
				setToken(token)
				return token
			})
	},
	logout() {
		localStorage.clear();
	},
	changePassword(newPassword, oldPassword) {
		return api.post(`students/`, {newPassword, oldPassword})
	},
	fetchUser() {
		return api.get('students/')
	}
}